import useNetwork from '../../models/useNetwork'
import useNode from '../../models/useNode'
import DiagramFrame from './DiagramFrame'
import DiagramNode from './DiagramNode'
import Typography from '@mui/material/Typography'
import ModalNode from '../ModalNode'
import NextPrev from './NextPrev'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

export default function OnboardNode() {
  const { networks } = useNetwork()
  const { nodes } = useNode()
  const network = networks[0]

  return (
    <>
      <Grid size={{ xs: 12, sm: 3.5 }} />
      <Grid size={{ xs: 12, sm: 8.5 }}>
        <Typography variant="h1">Add a node</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 3.5 }} sx={{
        paddingTop: 4
      }}>
        <Typography variant="h5">
          Add a{' '}
          <Box component="span" sx={{
            color: 'primary.main'
          }}>
            Compute Node
          </Box>{' '}
          that you want to control with your LLM.
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 8.5 }}>
        <DiagramFrame
          left={<DiagramNode label="Language Model" type="llm" />}
          middle={<DiagramNode type="network" label={network?.name} currentColor />}
          right={<DiagramNode label="Compute Node" type="node" />}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3.5 }}>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            marginBottom: 3
          }}>
          Enter the name of the node you want to add, then run the noBGP install command in its terminal.
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 8.5 }}>
        <ModalNode inline />
      </Grid>
      <Grid
        size={12}
        sx={{
          marginTop: 4,
          textAlign: 'right'
        }}>
        <NextPrev
          label="Run command to continue"
          prev="/onboard/welcome"
          next="/onboard/llm"
          auto={nodes}
          disabled
          skip
        />
      </Grid>
    </>
  )
}
